import RichMessage from "./RichMessage";
export default RichMessage;
